// useBusinessValidator.ts
import { validateBusinessNumber } from '@/api/company';

export const useBusinessValidator = () => {
  const getStatusText = (code: string) => {
    const statusMap: { [key: string]: string } = {
      '01': '계속사업자',
      '02': '휴업자',
      '03': '폐업자',
    };
    return statusMap[code] || code;
  };

  const getBusinessStatus = async (businessNo: string): Promise<string> => {
    try {
      if (!businessNo || businessNo.trim() === '') {
        return '사업자번호 없음';
      }
      const response = await validateBusinessNumber(businessNo);

      if (response.data?.data?.[0]) {
        const statusCode = response.data.data[0].b_stt_cd;
        return getStatusText(statusCode);
      }

      return '조회 결과 없음';
    } catch (err) {
      console.error('API 오류:', err);
      return '조회 실패';
    }
  };

  return {
    getBusinessStatus,
  };
};
